// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "./Skillet.res.mjs";
import * as PilotContent$LiteracyplanetTupperware from "../v3/PilotContent.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";

function SkilfulContent$Skilful(props) {
  return React.createElement("div", {
              className: Skillet$LiteracyplanetTupperware.SkilfulContent.className
            }, props.children);
}

var Skilful = {
  make: SkilfulContent$Skilful
};

function SkilfulContent(props) {
  var children = props.children;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  if (Curry._1(hasFlag, {
          NAME: "Unleash",
          VAL: "temp_hasPilotLayout"
        })) {
    return React.createElement(PilotContent$LiteracyplanetTupperware.make, {
                children: children
              });
  } else {
    return React.createElement(SkilfulContent$Skilful, {
                children: children
              });
  }
}

var make = SkilfulContent;

var $$default = SkilfulContent;

export {
  Skilful ,
  make ,
  $$default as default,
}
/* react Not a pure module */
